import { RemoteValidateMeter } from "../../../../data/usecases/meter/remote-validate-meter";
import { ValidateMeter } from "../../../../domain/usecases/validate-meter";
import { makeApiUrl, makeAxiosHttpClient } from "../../http";

export const makeRemoteValidateMeter = (): ValidateMeter =>
  new RemoteValidateMeter(
    makeApiUrl("/meters/validate-meter"),
    makeAxiosHttpClient()
  );
